export default __webpack_public_path__ + "static/media/Pet_Lover.f52b2aad.svg";